var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('img',{attrs:{"src":require("../assets/img/footer/footer.jpg"),"alt":"menu"}}),_vm._v(" "),_c('div',{staticClass:"copy",on:{"click":_vm.toBeiAn}},[_vm._v("水成科技 版权所有 沪ICP备19022868号-1 沪公网安备 31011002001095号")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4e3630","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 